// Which Sidebar menu targets open as a workspace tab instead of a normal
// full-page navigation, and what title their tab gets. Scoped to the
// ticket/mission items an employee's own menu (get_menu_item) actually
// exposes - reports/settings/feedback/profile stay full-page navigations,
// they don't make sense tiled into a quarter-screen pane. See
// WorkspacePane.jsx for the matching mini route table.
export const WORKSPACE_TAB_TITLES = {
  '/dashboard': 'تیکت‌ها',
  '/tickets': 'همه',
  '/tickets/responded': 'تیکت‌های پاسخ داده‌شده',
  '/tickets/referred': 'تیکت‌های ارجاع‌شده',
  '/missions/define': 'ماموریت‌ها',
  '/missions/my': 'ماموریت‌های من',
};

export function isWorkspaceEligiblePath(path) {
  return path in WORKSPACE_TAB_TITLES;
}

export function workspaceTabTitle(path) {
  return WORKSPACE_TAB_TITLES[path] || path;
}
